import {
  Badge,
  BadgeProps,
  Button,
  ButtonProps,
  Icons,
  LoadingIndicator,
} from '@commenda/kakashi';
import { ONBOARDING_STEP_STATUS, OnboardingStepStatus } from './types';

export type OnboardingItemButtonPosition = 'right' | 'down';

export const OnboardingItem = ({
  description,
  heading,
  badge,
  button,
  idx,
  status,
}: {
  icon: React.ReactElement;
  heading: string;
  description: string;
  button: {
    label: string;
    disabled: boolean;
    icon: React.ReactNode;
    onClick: () => void;
    variant?: ButtonProps['variant'];
    isLoading?: boolean;
    position?: OnboardingItemButtonPosition;
  };
  idx: number;
  status: OnboardingStepStatus;
  badge: {
    label: string;
    variant: BadgeProps['variant'];
  } | null;
}) => {
  const buttonPosition = button?.position ?? 'down';

  return (
    <div className="flex gap-xl">
      <div className="flex gap-lg w-full">
        {status === ONBOARDING_STEP_STATUS.NOT_STARTED && (
          <div className="shrink-0 size-6 flex justify-center items-center bg-bg-secondary rounded-xs txt-small-medium text-text-primary">
            {idx + 1}
          </div>
        )}
        {status === ONBOARDING_STEP_STATUS.IN_PROGRESS && (
          <div className="shrink-0 size-6 flex justify-center items-center bg-bg-warning rounded-xs">
            <Icons.Hourglass01 className="size-4 text-fg-warning" />
          </div>
        )}
        {status === ONBOARDING_STEP_STATUS.COMPLETED && (
          <div className="shrink-0 size-6 flex justify-center items-center bg-bg-success rounded-md">
            <Icons.Check className="size-4 text-fg-success" />
          </div>
        )}
        <div
          className={`flex w-full ${buttonPosition === 'down' ? 'flex-col gap-xl' : 'items-start'
            }`}
        >
          <div className="flex flex-col gap-xxs">
            <div className="flex items-center gap-md">
              <div className="txt-large-bold">{heading}</div>
              {badge && (
                <Badge size="sm" variant={badge.variant}>
                  {badge.label}
                </Badge>
              )}
            </div>
            <p className="txt-small-regular text-text-secondary">
              {description}
            </p>
          </div>
          {buttonPosition === 'right' && <div className="flex-1" />}
          <Button
            size="md"
            variant={button.variant}
            disabled={button.disabled}
            className={`h-fit w-fit ${buttonPosition === 'right' ? 'ml-lg' : ''}`}
            onClick={button.onClick}
          >
            {button.isLoading ? <LoadingIndicator size={20} /> : null}
            {button.label}
            {button.icon}
          </Button>
        </div>
      </div>
    </div>
  );
};
